// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import type {
  CreateDelegationRequestDto,
  DelegationResponseDto,
  DelegationSearchResponseDto,
  SetDelegationStatusRequestDto,
} from "../dto/delegationDtos";
import type {
  CreateDelegationInputModel,
  DelegationModel,
  DelegationSearchResultModel,
  SetDelegationStatusInputModel,
} from "../models/delegationModels";

export function mapDelegationResponseDtoToModel(
  dto: DelegationResponseDto,
): DelegationModel {
  return {
    delegationId: dto.delegationId,
    tenantId: dto.tenantId,
    workTaskId: dto.workTaskId,
    delegateType: dto.delegateType,
    delegateId: dto.delegateId,
    ...(dto.delegatorActorId != null
      ? { delegatorActorId: dto.delegatorActorId }
      : {}),
    status: dto.status,
    offeredAtUtc: dto.offeredAtUtc,
    createdAtUtc: dto.createdAtUtc,
    ...(dto.updatedAtUtc != null
      ? { updatedAtUtc: dto.updatedAtUtc }
      : {}),
    ...(dto.respondedAtUtc != null
      ? { respondedAtUtc: dto.respondedAtUtc }
      : {}),
    ...(dto.completedAtUtc != null
      ? { completedAtUtc: dto.completedAtUtc }
      : {}),
    ...(dto.notes != null ? { notes: dto.notes } : {}),
  };
}

export function mapDelegationSearchResponseDtoToModel(
  dto: DelegationSearchResponseDto,
): DelegationSearchResultModel {
  return {
    delegations: dto.delegations.map(mapDelegationResponseDtoToModel),
    pageNumber: dto.pageNumber,
    pageSize: dto.pageSize,
    totalCount: dto.totalCount,
  };
}

export function toCreateDelegationRequestDto(
  tenantId: string,
  input: CreateDelegationInputModel,
): CreateDelegationRequestDto {
  return {
    tenantId,
    workTaskId: input.workTaskId,
    delegateType: input.delegateType,
    delegateId: input.delegateId,
    ...(input.notes !== undefined ? { notes: input.notes } : {}),
  };
}

export function toSetDelegationStatusRequestDto(
  tenantId: string,
  input: SetDelegationStatusInputModel,
): SetDelegationStatusRequestDto {
  return {
    tenantId,
    delegationId: input.delegationId,
    status: input.status,
  };
}
